module.exports = __webpack_public_path__ + "static/media/3f8.d45c2660.jpg";